export default __webpack_public_path__ + "static/content-1a0172deb215991c38654d4ac63749be.jpg";